import React, { forwardRef } from 'react';
import get from 'lodash.get';
import { StyledInput } from './styles';

const CommonComponent = ({ error, label, helperText, reference, ...props }) => {
  return (
    <StyledInput {...props} ref={reference} variant="outlined" label={label} error={error} helperText={helperText} />
  );
};

const ReactHookInput = forwardRef(
  ({ name, type = 'text', placeholder, dataTestSuffix, defaultValue, errors, onChange, onBlur }, ref) => {
    const error = get(errors, name, false);

    return (
      <CommonComponent
        reference={ref}
        onChange={onChange}
        onBlur={onBlur}
        name={name}
        id={name}
        type={type}
        defaultValue={defaultValue}
        label={placeholder}
        helperText={error?.message}
        data-test={`booking-finalize-${dataTestSuffix}`}
        error={!!error}
      />
    );
  },
);

export { ReactHookInput };
